import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'

import { type ExportOptionsConfig, type ExportOptionsValues, IntegrationServiceId } from '../../../../common/integrations'
import { TagDropdown } from './TagDropdown'
import { UserGroupDropdown } from './UserGroupDropdown'

export interface ExportOptionsSectionProps {
  serviceId: IntegrationServiceId
  config: ExportOptionsConfig
  isAppendingToExisting: boolean
}

export const ExportOptionsSection: React.FC<ExportOptionsSectionProps> = ({ serviceId, config, isAppendingToExisting }) => {
  const { watch } = useFormContext<{ exportOptions?: ExportOptionsValues }>()
  const selectedVisibleTo = watch('exportOptions.visibleTo')

  return (
    <>
      {config.tags ? <TagDropdown serviceId={serviceId} config={config.tags} /> : null}
      {config.visibleTo ? <UserGroupDropdown serviceId={serviceId} config={config.visibleTo} /> : null}
      {config.visibleTo && isAppendingToExisting && selectedVisibleTo ? (
        <Row className='mt-1'>
          <Col xs={12}>
            <div className='paragraph-extra-small'>The selected visibility will also be applied to the existing record.</div>
          </Col>
        </Row>
      ) : null}
    </>
  )
}
